<template>
    <div id="subSystemList" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">Subsystem</div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="subSystemActive" v-on:click="getSubSystemActive(this)" :class="'btn btn-secondary '+ subSystemActive"> Close Subsystem </button>
                                    <button type="button" id="glTransactionActive" v-on:click="getGLTransactionActive(this)" :class="'btn btn-secondary '+ glTransactionActive"> Close GL Transaction </button>
                                    <button type="button" id="monthActive" v-on:click="getMonthActive(this)" :class="'btn btn-secondary '+ monthActive"> Close Month </button>
                                    <button type="button" id="yearActive" v-on:click="getYearActive(this)" :class="'btn btn-secondary '+ yearActive"> Close Year </button>
                                </div>
                            </div>
                        </div>
                        <section class="internal-container border-top-table-fl">
                            <div class="purchase-order-create-main table-responsive-sm" v-if="flag == 'year'">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Year</th>
                                            <th scope="col">Close</th>
                                        </tr>    
                                    </thead>
                                    <tbody>
                                        <template v-if="yearArr != undefined && yearArr.length > 0">
                                            <tr v-for="(yData, index) in yearArr" v-bind:key="index">
                                                <td>{{ yData.year }}</td>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" :id="'switchYear'+index" @input="onSwitchInput($event,index)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>    
                                            <tr>
                                                <td colspan="2" style="text-align:center;">
                                                    No Data Found.
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>        
                            </div>
                            <div class="purchase-order-create-main table-responsive-sm" v-else-if="flag == 'month'">
                                <p v-if="monthBatchProcess" id="monthGLBatchMsg" class="alert-success p-2">Current batch {{monthBatchNum}} is processing. Please wait while we update gl balance !!</p>
                                <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Month</th>
                                            <th scope="col">Close</th>
                                        </tr>    
                                    </thead>
                                    <tbody>
                                        <template v-if="monthArr != undefined && monthArr.length > 0">
                                            <tr v-for="(mData, index) in monthArr" v-bind:key="index">
                                                <td>{{ mData.current }}</td>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" :id="'switchMonth'+index" @input="onSwitchInput($event,index)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>    
                                            <tr>
                                                <td colspan="2" style="text-align:center;">
                                                    No Data Found.
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="purchase-order-create-main table-responsive-sm" v-else-if="flag == 'gl'">
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Current</th>
                                            <th scope="col">Next</th>
                                            <th scope="col">Close</th>
                                        </tr>    
                                    </thead>
                                    <tbody>
                                        <template v-if="glTransactionArr != undefined && glTransactionArr.length > 0">
                                            <tr v-for="(glData, index) in glTransactionArr" v-bind:key="index">
                                                <td>{{ glData.current }}</td>
                                                <td>{{ glData.next }}</td>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" :id="'switchGL'+index" @input="onSwitchInput($event,index)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>    
                                            <tr>
                                                <td colspan="3" style="text-align:center;">
                                                    No Data Found.
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="purchase-order-create-main table-responsive-sm" v-else>
                                <table aria-describedby="table" class="table table-sm table-bordered font-1">
                                    <thead>
                                        <tr class="table-primary">
                                            <th scope="col">Type</th>
                                            <th scope="col">Current</th>
                                            <th scope="col">Next</th>
                                            <th scope="col">Close</th>
                                            <th scope="col">Reopen</th>
                                        </tr>    
                                    </thead>
                                    <tbody>
                                        <template v-if="subSystemArr != undefined && subSystemArr.length > 0">
                                            <tr v-for="(sub, index) in subSystemArr" v-bind:key="index">
                                                <td>{{ sub.type }}</td>
                                                <td>{{ sub.current }}</td>
                                                <td>{{ sub.next }}</td>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" :id="'switch'+index" @input="onSwitchInput($event,index)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                                <td>
                                                    <label class="switch">
                                                        <input type="checkbox" :id="'switchReopen'+index" @input="onReopenSwitchInput($event,index)">
                                                        <span class="slider round"></span>
                                                    </label>
                                                </td>
                                            </tr>
                                        </template>
                                        <template v-else>    
                                            <tr>
                                                <td colspan="5" style="text-align:center;">
                                                    No Data Found.
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>    
                            </div>
                            <div class="btn-groups">
                                <button type="submit" id="closeSubSystemBtn" class="btn btn-primary" v-on:click.prevent="closeSubSystem" >
                                    <i class="fp-save"> </i>  Save
                                </button>
                            </div>
                        </section>    
                    </div>
                </div>        
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>    
        </div>    
    </div>    
</template>
<script>
import Vue from "vue";


import {commonMixins} from '../../mixins/commonMixins';

let msgServer;
export default {
    name: "SubSystemList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Subsystem | " +process.env.COPYRIGHT_NAME
    },
    
    mixins:[commonMixins],
    data: () => ({
        permissions: [],
        cantAccessPage: "",
        loading:false,
        subSystemArr:[],
        monthArr:[],
        yearArr:[],
        flag:"subsystem",
        subSystemActive:'active',
        monthActive:'',
        yearActive:'',
        glTransactionActive:'',
        glTransactionArr:[],
        monthBatchProcess:false,
        monthBatchNum:"",
        monthBatchId:0,
        batchError:false,
        batchErrorMsg:""
    }),
    watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_sub_system') {
                        self.cantAccessPage = true;
                    }
                }
            }

        },
    },
    created: function() {

    },
    mounted: function() {
        var self = this;
        self.getPermissions();
        self.listSubSystem('subsystem');

    },
    methods: {
        listSubSystem(flag) {
            var self = this;
            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/sub-system/list",
                type: "POST",
                data:{flag:flag},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.status == "success") {
                        if (self.flag == "year") {
                            self.yearArr = data.content;
                            for(var i = 0;i < self.yearArr.length;i++) {
                                if (self.yearArr[i] != null) {
                                    $("#switchYear"+i).prop('checked',false);
                                    self.$set(self.yearArr[i],'is_closed',0);
                                }
                            }
                        }else if (self.flag == "month") {
                            self.monthArr = data.content;
                            for(var i = 0;i < self.monthArr.length;i++) {
                                if (self.monthArr[i] != null) {
                                    $("#switchMonth"+i).prop('checked',false);
                                    self.$set(self.monthArr[i],'is_closed',0);
                                }
                            }
                        }else if (self.flag == "gl") {
                            self.glTransactionArr = data.content;
                            for(var i = 0;i < self.glTransactionArr.length;i++) {
                                if (self.glTransactionArr[i] != null) {
                                    $("#switchGL"+i).prop('checked',false);
                                    self.$set(self.glTransactionArr[i],'is_closed',0);
                                }
                            }
                        }else{
                            self.subSystemArr = data.content;
                            for(var i = 0;i < self.subSystemArr.length;i++) {
                                if (self.subSystemArr[i] != null) {
                                    $("#switch"+i).prop('checked',false);
                                    self.$set(self.subSystemArr[i],'is_closed',0);
                                    $("#switchReopen"+i).prop('checked',false);
                                    self.$set(self.subSystemArr[i],'is_reopened',0);
                                }
                            }
                        }
                        if (data.batchId != undefined){
                            self.monthBatchId = data.batchId;
                            self.monthBatchNum = data.batch;
                            self.monthBatchProcess = true;
                            self.checkBatchStatus();
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,false,'sub-system-list')
                }
            });
        },
        onSwitchInput(evt,index) {
            var self = this;
            if (self.flag == "year") {
                if (evt.target.checked) {
                    self.$set(self.yearArr[index],'is_closed',1);
                }else{
                    self.$set(self.yearArr[index],'is_closed',0);
                }
            }else if (self.flag == "month") {
                if (evt.target.checked) {
                    self.$set(self.monthArr[index],'is_closed',1);
                }else{
                    self.$set(self.monthArr[index],'is_closed',0);
                }
            }else if (self.flag == "gl") {
                if (evt.target.checked) {
                    self.$set(self.glTransactionArr[index],'is_closed',1);
                }else{
                    self.$set(self.glTransactionArr[index],'is_closed',0);
                }
            }else{
                if (evt.target.checked) {
                    self.$set(self.subSystemArr[index],'is_closed',1);
                }else{
                    self.$set(self.subSystemArr[index],'is_closed',0);
                }
            }
        },
        closeSubSystem() {
            var self = this;
            var error = false;
            var closedCount = 0;
            var paramsArr = [];
            var bothCount = 0;
            var reopenCount = 0;
            
            if (self.flag == "year") {
                if (self.yearArr.length > 0) {
                    for(var i = 0;i < self.yearArr.length;i++) {
                        if (self.yearArr[i] != null) {
                            if (self.yearArr[i].is_closed == 1) {
                                closedCount++;
                                paramsArr.push({
                                    id:self.yearArr[i].id,
                                    year:self.yearArr[i].year,
                                    next_year:self.yearArr[i].next_year
                                })
                            }
                        }
                    }
                }else{
                    error = true;
                    self.$swal('',"No Data Found.",'info');
                    return;
                }
            }else if (self.flag == "month") {
                if (self.monthArr.length > 0) {
                    for(var i = 0;i < self.monthArr.length;i++) {
                        if (self.monthArr[i] != null) {
                            if (self.monthArr[i].is_closed == 1) {
                                closedCount++;
                                paramsArr.push({
                                    id:self.monthArr[i].id,
                                    year:self.monthArr[i].year,
                                    ss_year_id:self.monthArr[i].ss_year_id,
                                    month:self.monthArr[i].month,
                                    month_text:self.monthArr[i].current
                                })
                            }
                        }
                    }
                }else{
                    error = true;
                    self.$swal('',"No Data Found.",'info');
                    return;
                }
            }else if (self.flag == "gl") {
                if (self.glTransactionArr.length > 0) {
                    for(var i = 0;i < self.glTransactionArr.length;i++) {
                        if (self.glTransactionArr[i] != null) {
                            if (self.glTransactionArr[i].is_closed == 1) {
                                closedCount++;
                                paramsArr.push({
                                    id:self.glTransactionArr[i].id,
                                    type:self.glTransactionArr[i].type,
                                    current_month:self.glTransactionArr[i].current_month,
                                    next_month:self.glTransactionArr[i].next_month,
                                    year:self.glTransactionArr[i].year,
                                    is_closed:self.glTransactionArr[i].is_closed,
                                    ss_year:self.glTransactionArr[i].ss_year,
                                    ss_month:self.glTransactionArr[i].ss_month,
                                    next_year:self.glTransactionArr[i].next_year,
                                    current_period:self.glTransactionArr[i].current,
                                })
                            }
                        }
                    }
                }else{
                    error = true;
                    self.$swal('',"No Data Found.",'info');
                    return;
                }
            }else{
                if (self.subSystemArr.length > 0) {
                    for(var i = 0;i < self.subSystemArr.length;i++) {
                        if (self.subSystemArr[i] != null) {
                            if (self.subSystemArr[i].is_closed == 1 && self.subSystemArr[i].is_reopened == 1) {
                                bothCount++;
                                continue;
                            }
                            if (self.subSystemArr[i].is_closed == 1 || self.subSystemArr[i].is_reopened == 1) {
                                if (self.subSystemArr[i].is_closed == 1) {
                                    closedCount++;
                                }
                                if (self.subSystemArr[i].is_reopened == 1) {
                                    reopenCount++;
                                }
                                paramsArr.push({
                                    id:self.subSystemArr[i].id,
                                    type:self.subSystemArr[i].type,
                                    current_month:self.subSystemArr[i].current_month,
                                    next_month:self.subSystemArr[i].next_month,
                                    year:self.subSystemArr[i].year,
                                    is_closed:self.subSystemArr[i].is_closed,
                                    ss_year:self.subSystemArr[i].ss_year,
                                    ss_month:self.subSystemArr[i].ss_month,
                                    next_year:self.subSystemArr[i].next_year,
                                    current_period:self.subSystemArr[i].current,
                                    is_reopened:self.subSystemArr[i].is_reopened,
                                })
                            }
                        }
                    }
                }else{
                    error = true;
                    self.$swal('',"No Data Found.",'info');
                    return;
                }
            }
            
            if (self.flag == "subsystem") {
                if (closedCount == 0 && reopenCount == 0 && bothCount == 0) {
                    error = true;
                    var message = "Please mark Subsystem to Close or Reopen.";
                    self.$swal('',message,'info');
                    return;
                }
                if (bothCount > 0) {
                    self.$swal('',"Subsystem cannot be closed and reopened at same time.",'info');
                    return;
                }
            }else{
                if (closedCount == 0) {
                    error = true;
                    var message = "Please mark Subsystem to Close.";
                    if (self.flag == "year") {
                        message = "Please mark Year to Close.";
                    }else if (self.flag == "month") {
                        message = "Please mark Month to Close.";
                    }else if (self.flag == "gl") {
                        message = "Please mark GL Transaction to Close.";
                    }
                    self.$swal('',message,'info');
                    return;
                }
            }

            if (!error) {
                var confirmMessage = "Are you sure that you want to close the Subsystem?";
                if (self.flag == "year") {
                    confirmMessage = "Are you sure that you want to close the Year?";
                }else if (self.flag == "month") {
                    confirmMessage = "Are you sure that you want to close the Month?";
                }else if (self.flag == "gl") {
                    confirmMessage = "Are you sure that you want to close GL Transaction?";
                }else{
                    if (closedCount > 0 && reopenCount > 0) {
                        confirmMessage = "Are you sure that you want to close or reopen the Subsystem?";
                    }else if (reopenCount > 0 && closedCount < 1) {
                        confirmMessage = "Are you sure that you want to reopen the Subsystem?";
                    }
                }
                if (confirm(confirmMessage)) {
                    self.loading = true;
                    $.ajax({
                        url: process.env.ROOT_API + "/sub-system/close",
                        type: "POST",
                        data:{sub_system:JSON.stringify(paramsArr),flag:self.flag},
                        headers: this.ajxHeaders,
                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (data.status == "success") {
                                if (self.flag == "year") {
                                    self.$swal('',"Year Closed Successfully.",'success');
                                }else if (self.flag == "month") {
                                    self.$swal('',"Month Closed Successfully.",'success');
                                    if (data.content.batch != undefined && data.content.batch != "") {
                                        if (data.content.batch_id != undefined && data.content.batch_id != null) {
                                            if (data.content.batch_id > 0) {
                                                self.monthBatchId = data.content.batch_id;
                                                self.monthBatchNum = data.content.batch;
                                                self.monthBatchProcess = true;
                                                self.checkBatchStatus();
                                            }
                                        }
                                    }
                                }else if (self.flag == "gl") {
                                    self.$swal('',"GL Transaction Closed Successfully.",'success');
                                }else{
                                    //Sub Systems not closed
                                    var successMsg = "Subsystem Closed Successfully.";
                                    if (closedCount > 0 && reopenCount > 0) {
                                        successMsg = "Subsystem Closed or Reopened Successfully.";
                                    }else if (reopenCount > 0 && closedCount < 1) {
                                        successMsg = "Subsystem Reopened Successfully.";
                                    }
                                    if (data.content.not_stored != undefined) {
                                        if (data.content.not_stored != "") {
                                            self.$swal('',data.content.not_stored,'info');
                                        }else{
                                            self.$swal('',successMsg,'success');
                                        }
                                    }else{
                                        self.$swal('',successMsg,'success'); 
                                    }
                                }
                            }else{
                                self.$swal('',data.message,'info');
                            }
                            self.listSubSystem(self.flag);
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,false,'sub-system-close')
                        }
                    });
                }else{
                    // for(var i = 0;i < self.subSystemArr.length;i++) {
                    //     if (self.subSystemArr[i] != null) {
                    //         $("#switch"+i).prop('checked',false);
                    //         self.$set(self.subSystemArr[i],'is_closed',0);
                    //     }
                    // }
                }
            }
        },
        getSubSystemActive() {
            var self = this;
            self.subSystemActive = 'active';
            self.monthActive = '';
            self.yearActive = '';
            self.glTransactionActive = '';
            self.flag = 'subsystem';
            self.listSubSystem('subsystem');
        },
        getMonthActive() {
            var self = this;
            self.subSystemActive = '';
            self.monthActive = 'active';
            self.yearActive = '';
            self.glTransactionActive = '';
            self.flag = 'month';
            self.listSubSystem('month');
        },
        getYearActive() {
            var self = this;
            self.subSystemActive = '';
            self.monthActive = '';
            self.yearActive = 'active';
            self.glTransactionActive = '';
            self.flag = 'year';
            self.listSubSystem('year');
        },
        getGLTransactionActive() {
            var self = this;
            self.subSystemActive = '';
            self.monthActive = '';
            self.yearActive = '';
            self.glTransactionActive = 'active';
            self.flag = 'gl';
            self.listSubSystem('gl');
        },
        onReopenSwitchInput(evt,index) {
            var self = this;
            if (evt.target.checked) {
                self.$set(self.subSystemArr[index],'is_reopened',1);
            }else{
                self.$set(self.subSystemArr[index],'is_reopened',0);
            }
        },
        checkBatchStatus:function(){
            var self =  this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.monthBatchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.monthBatchProcess = false;
                        self.listSubSystem('month');
                        sse.close();
                    }else if (data.status == "2") {
                        self.monthBatchProcess = false;
                        self.batchError = true;
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },
    }
}
</script>
<style scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #2196F3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/accounting/SubSystemList.vue